import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PoBreadcrumb, PoDialogService, PoNotificationService } from '@po-ui/ng-components';
import { EmpresaSocioService } from './empresa-socio.service';

@Component({
  selector: 'app-empresa-socio',
  templateUrl: './empresa-socio.component.html',
  styleUrls: ['./empresa-socio.component.css'],
  standalone: false
})
export class EmpresaSocioComponent {

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', link: '/home' },
      { label: 'Financeiro' },
      { label: 'Empresa Sócios' }
    ]
  };

  empresaId: number | null = null;
  arquivoNome = '';
  arquivoPlanilha: File | null = null;
  isLoading = false;

  constructor(
    private readonly empresaSocioService: EmpresaSocioService,
    private readonly poDialogService: PoDialogService,
    private readonly poNotificationService: PoNotificationService
  ) {}

  requestRelatorio(form: NgForm): void {
    if (form.invalid) {
      this.poNotificationService.warning('Verifique os dados do formulário.');
      return;
    }

    if (this.arquivoPlanilha) {
      this.enviarPorPlanilha();
      return;
    }

    this.enviarPorEmpresa(this.empresaId);
  }

  onArquivoSelecionado(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    this.processarArquivo(file);
  }

  onDropArquivo(event: DragEvent): void {
    event.preventDefault();
    const file = event.dataTransfer?.files?.[0];
    if (!file) return;
    this.processarArquivo(file);
  }

  onDragOverArquivo(event: DragEvent): void {
    event.preventDefault();
  }

  limparArquivo(): void {
    this.arquivoNome = '';
    this.arquivoPlanilha = null;
  }

  onEmpresaChange(): void {
    if (this.empresaId != null && this.empresaId > 0) {
      this.limparArquivo();
    }
  }

  private processarArquivo(file: File): void {
    const extensaoValida = /\.(csv|xlsx|xls)$/i.test(file.name);
    if (!extensaoValida) {
      this.poNotificationService.warning('Envie uma planilha .csv, .xlsx ou .xls.');
      return;
    }

    this.arquivoPlanilha = file;
    this.arquivoNome = file.name;
    this.empresaId = null;
    this.poNotificationService.success(
      'Planilha carregada. Clique em "Gerar Relatório" para enviar a lista de empresas.'
    );
  }

  private enviarPorPlanilha(): void {
    if (!this.arquivoPlanilha) return;

    this.isLoading = true;
    this.empresaSocioService.requestEmpresaSocioPorPlanilha(this.arquivoPlanilha).subscribe({
      next: () => this.tratarSucesso(true),
      error: (err) => this.tratarErro(err)
    });
  }

  private enviarPorEmpresa(empresaId: number | null): void {
    this.isLoading = true;
    this.empresaSocioService.requestEmpresaSocio(empresaId).subscribe({
      next: () => this.tratarSucesso(false),
      error: (err) => this.tratarErro(err)
    });
  }

  private tratarSucesso(porPlanilha: boolean): void {
    this.isLoading = false;
    this.poDialogService.alert({
      title: 'Relatório - Empresa Sócios',
      message: porPlanilha
        ? 'Planilha enviada com sucesso. Dentro de instantes você receberá um e-mail com o relatório das empresas informadas.'
        : 'Relatório solicitado com sucesso (todas as empresas ou empresa informada). Dentro de instantes você receberá um e-mail com a planilha.'
    });
    this.empresaId = null;
    this.limparArquivo();
  }

  private tratarErro(err: unknown): void {
    this.isLoading = false;
    const erro = err as { error?: { error?: string; message?: string }; message?: string };
    const mensagem =
      erro?.error?.error ||
      erro?.error?.message ||
      erro?.message ||
      'Erro ao solicitar o relatório de Empresa Sócios.';
    this.poNotificationService.error(mensagem);
  }
}
